import CheckBox from "../../../../../components/checkBox/CheckBox";
import Utils from "../../../../../utils/Utils";
import React, {useEffect, useState} from "react";
import {setStateAssistente} from "../../../../../actions/IndexActions";
import {useDispatch, useSelector} from "react-redux";

function RequisitiPerIscrizione(props) {

    const [state, setState] = useState({})
    const dispatch = useDispatch();
    const getAssistente = useSelector(state => state.wizardReducer)
    const [modifica,setModifica]=useState(false)
    useEffect(() =>{
        if(getAssistente && getAssistente.requisitiIscrizione){
            let newState = getAssistente.requisitiIscrizione
            setState(newState)
        }
        if (getAssistente && getAssistente.requisitiIscrizione && getAssistente && getAssistente.assistente && getAssistente.assistente.idCandidato){
            setModifica(true)
        }
    },[])

    useEffect(() =>{
        dispatch(setStateAssistente("requisitiIscrizione",state))
    },[state, setState])

    return (
        <div>
            <div>
                <span style={{fontSize: "16px", fontWeight: "bold"}}>
                    Possono Iscriversi al Registro Assistenti familiari coloro che dichiarano:
                </span>
                <fieldset disabled={modifica}>
                <div className={"row"}>
                    <div className={"col-1"} style={{flex: "0 0 2%"}}>
                        <CheckBox id={"checkboxStep3IscriversiRegistro1"}
                                  onChange={(event) => setState(Utils.riceviValorePadre(state, event.target.id, event.target.checked, "iscriversiRegistro"))}
                                  checked={state && state.iscriversiRegistro && state.iscriversiRegistro.checkboxStep3IscriversiRegistro1 ? state.iscriversiRegistro.checkboxStep3IscriversiRegistro1 : false}/>
                    </div>
                    <div className={"col-11"} style={{marginTop: ".6rem"}}>
                        <span>di essere a conoscenza che possono essere eseguiti controlli diretti ad accertare la validità delle informazioni fornite;</span>
                    </div>
                </div>
                <div className={"row"}>
                    <div className={"col-1"} style={{flex: "0 0 2%"}}>
                        <CheckBox id={"checkboxStep3IscriversiRegistro2"}
                                  onChange={(event) => setState(Utils.riceviValorePadre(state, event.target.id, event.target.checked, "iscriversiRegistro"))}
                                  checked={state && state.iscriversiRegistro && state.iscriversiRegistro.checkboxStep3IscriversiRegistro2 ? state.iscriversiRegistro.checkboxStep3IscriversiRegistro2 : false}/>
                    </div>
                    <div className={"col-11"} style={{marginTop: ".6rem"}}>
                    <span>di essere consapevole che: in caso di attivazione di rapporto di lavoro lo stesso intercorre esclusivamente tra
                        l'assistente familiare e il benificiario con esclusione di qualsiasi responsabilità del servizio di cura familiare;</span>
                    </div>
                </div>
                <div className={"row"}>
                    <div className={"col-1"} style={{flex: "0 0 2%"}}>
                        <CheckBox id={"checkboxStep3IscriversiRegistro3"}
                                  onChange={(event) => setState(Utils.riceviValorePadre(state, event.target.id, event.target.checked, "iscriversiRegistro"))}
                                  checked={state && state.iscriversiRegistro && state.iscriversiRegistro.checkboxStep3IscriversiRegistro3 ? state.iscriversiRegistro.checkboxStep3IscriversiRegistro3 : false}/>
                    </div>
                    <div className={"col-11"} style={{marginTop: ".6rem"}}>
                        <span>il rapporto di lavoro andrà disciplinato da apposito contratto da stipularsi a carico del beneficiario presso enti competenti in materia di contrattazione;</span>
                    </div>
                </div>
                <div className={"row"}>
                    <div className={"col-1"} style={{flex: "0 0 2%"}}>
                        <CheckBox id={"checkboxStep3IscriversiRegistro4"}
                                  onChange={(event) => setState(Utils.riceviValorePadre(state, event.target.id, event.target.checked, "iscriversiRegistro"))}
                                  checked={state && state.iscriversiRegistro && state.iscriversiRegistro.checkboxStep3IscriversiRegistro4 ? state.iscriversiRegistro.checkboxStep3IscriversiRegistro4 : false}/>
                    </div>
                    <div className={"col-11"} style={{marginTop: ".6rem"}}>
                        <span>di aver compiuto 18 anni;</span></div>
                </div>
                <div className={"row"}>
                    <div className={"col-1"} style={{flex: "0 0 2%"}}>
                        <CheckBox id={"checkboxStep3IscriversiRegistro5"}
                                  onChange={(event) => setState(Utils.riceviValorePadre(state, event.target.id, event.target.checked, "iscriversiRegistro"))}
                                  checked={state && state.iscriversiRegistro && state.iscriversiRegistro.checkboxStep3IscriversiRegistro5 ? state.iscriversiRegistro.checkboxStep3IscriversiRegistro5 : false}/>
                    </div>
                    <div className={"col-11"} style={{marginTop: ".6rem"}}>
                        <span>se cittadino straniero, di essere in possesso di regolare permesso di soggiorno che consenta l'attività lavorativa;</span>
                    </div>
                </div>
                <div className={"row"}>
                    <div className={"col-1"} style={{flex: "0 0 2%"}}>
                        <CheckBox id={"checkboxStep3IscriversiRegistro6"}
                                  onChange={(event) => setState(Utils.riceviValorePadre(state, event.target.id, event.target.checked, "iscriversiRegistro"))}
                                  checked={state && state.iscriversiRegistro && state.iscriversiRegistro.checkboxStep3IscriversiRegistro6 ? state.iscriversiRegistro.checkboxStep3IscriversiRegistro6 : false}/>
                    </div>
                    <div className={"col-11"} style={{marginTop: ".6rem"}}>
                        <span>se cittadino straniero, di avere una sufficiente conoscenza della lingua italiana;</span>
                    </div>
                </div>
                <div className={"row"}>
                    <div className={"col-1"} style={{flex: "0 0 2%"}}>
                        <CheckBox id={"checkboxStep3IscriversiRegistro7"}
                                  onChange={(event) => setState(Utils.riceviValorePadre(state, event.target.id, event.target.checked, "iscriversiRegistro"))}
                                  checked={state && state.iscriversiRegistro && state.iscriversiRegistro.checkboxStep3IscriversiRegistro7 ? state.iscriversiRegistro.checkboxStep3IscriversiRegistro7 : false}/>
                    </div>
                    <div className={"col-11"} style={{marginTop: ".6rem"}}>
                        <span>se cittadino italiano, di avere assolto l'obbligo scolastico;</span></div>
                </div>
                <div className={"row"}>
                    <div className={"col-1"} style={{flex: "0 0 2%"}}>
                        <CheckBox id={"checkboxStep3IscriversiRegistro8"}
                                  onChange={(event) => setState(Utils.riceviValorePadre(state, event.target.id, event.target.checked, "iscriversiRegistro"))}
                                  checked={state && state.iscriversiRegistro && state.iscriversiRegistro.checkboxStep3IscriversiRegistro8 ? state.iscriversiRegistro.checkboxStep3IscriversiRegistro8 : false}/>
                    </div>
                    <div className={"col-11"} style={{marginTop: ".6rem"}}>
                        <span>di non avere conseguito condanne penali passate in giudicato e non avere carichi penali pendenti;</span>
                    </div>
                </div>
                <div className={"row"}>
                    <div className={"col-1"} style={{flex: "0 0 2%"}}>
                        <CheckBox id={"checkboxStep3IscriversiRegistro9"}
                                  onChange={(event) => setState(Utils.riceviValorePadre(state, event.target.id, event.target.checked, "iscriversiRegistro"))}
                                  checked={state && state.iscriversiRegistro && state.iscriversiRegistro.checkboxStep3IscriversiRegistro9 ? state.iscriversiRegistro.checkboxStep3IscriversiRegistro9 : false}/>
                    </div>
                    <div className={"col-11"} style={{marginTop: ".6rem"}}>
                        <span>di essere in possesso di attestato di frequenza alla formazione prevista dall'articolo 10 della LR n. 38/2017;</span>
                    </div>
                </div>
                <div className={"row"}>
                    <div className={"col-1"} style={{flex: "0 0 2%"}}>
                        <CheckBox id={"checkboxStep3IscriversiRegistro10"}
                                  onChange={(event) => setState(Utils.riceviValorePadre(state, event.target.id, event.target.checked, "iscriversiRegistro"))}
                                  checked={state && state.iscriversiRegistro && state.iscriversiRegistro.checkboxStep3IscriversiRegistro10 ? state.iscriversiRegistro.checkboxStep3IscriversiRegistro10 : false}/>
                    </div>
                    <div className={"col-11"} style={{marginTop: ".6rem"}}>
                    <span>nelle more della completa attuazione dell'articolo 10 della LR n. 38/2017, l'aver svolto attività formativa documentata
                        afferente all'area dell'assistenza familiare di qualsiasi durata, ovvero, in caso di assenza di esperienze formative,
                        l'aver svolto una attività lavorativa documentabile di almeno 12 mesi nel campo dell'assistenza familiare. L'iscrizione al Registro
                        su istanza dell'assistente familiare ha durata annuale. Ai fini della permanenza nel registro familiare l'interessato dovrà, alla scadenza dell'anno, ripresentare l'istanza di iscrizione*.</span>
                        <span className={"obbligatorietaColor"}>*</span>
                    </div>
                </div>
                </fieldset>
            </div>


            <div style={{marginTop:"2rem"}}>
                <span style={{fontSize: "16px", fontWeight: "bold"}}>
                    L'interessato si impegna a:
                </span>
                <fieldset disabled={modifica}>
                <div className={"row"}>
                    <div className={"col-1"} style={{flex: "0 0 2%"}}>
                        <CheckBox id={"checkboxStep3SiImpegna1"}
                                  onChange={(event) => setState(Utils.riceviValorePadre(state, event.target.id, event.target.checked, "impegna"))}
                                  checked={state && state.impegna && state.impegna.checkboxStep3SiImpegna1 ? state.impegna.checkboxStep3SiImpegna1 : false}/>
                    </div>
                    <div className={"col-11"} style={{marginTop: ".6rem"}}>
                    <span>comunicare tempestivamente eventuali variazioni che dovessero subentrare circa la situazione personale, familiare, lavorativa, etc.;</span>
                        <span className={"obbligatorietaColor"}>*</span>
                    </div>
                </div>
                <div className={"row"}>
                    <div className={"col-1"} style={{flex: "0 0 2%"}}>
                        <CheckBox id={"checkboxStep3SiImpegna2"}
                                  onChange={(event) => setState(Utils.riceviValorePadre(state, event.target.id, event.target.checked, "impegna"))}
                                  checked={state && state.impegna && state.impegna.checkboxStep3SiImpegna2 ? state.impegna.checkboxStep3SiImpegna2 : false}/>
                    </div>
                    <div className={"col-11"} style={{marginTop: ".6rem"}}>
                    <span>segnalare qualsiasi disservizio o problema verificatosi nello svolgimento del servizio;</span>
                        <span className={"obbligatorietaColor"}>*</span>
                    </div>
                </div>
                <div className={"row"} >
                    <div className={"col-1"} style={{flex: "0 0 2%"}}>
                        <CheckBox id={"checkboxStep3SiImpegna3"}
                                  onChange={(event) => setState(Utils.riceviValorePadre(state, event.target.id, event.target.checked, "impegna"))}
                                  checked={state && state.impegna && state.impegna.checkboxStep3SiImpegna3 ? state.impegna.checkboxStep3SiImpegna3 : false}/>
                    </div>
                    <div className={"col-11"} style={{marginTop: ".6rem"}}>
                    <span>a produrre, prima di un'eventuale assunzione, il certificato medico di idoneità alla mansione;</span>
                        <span className={"obbligatorietaColor"}>*</span>
                    </div>
                </div>
                </fieldset>
            </div>


        </div>
    )

}

export default RequisitiPerIscrizione
